import React from "react";
import { classNames } from "../styles/classNames";

type StatusTone = "success" | "error" | "warning" | "info";

interface StatusMessageProps {
  tone: StatusTone;
  title?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const TONE_CLASS: Record<StatusTone, string> = {
  success: "app-status-success",
  error: "app-status-error",
  warning: "app-status-warning",
  info: "app-status-info",
};

const TONE_TITLE_CLASS: Record<StatusTone, string> = {
  success: "app-status-title",
  error: "app-status-title",
  warning: "app-status-title",
  info: "app-status-title",
};

export default function StatusMessage({ tone, title, children, className }: StatusMessageProps) {
  return (
    <div className={classNames("app-status p-4", TONE_CLASS[tone], className)}>
      {title ? <p className={classNames("app-status-body app-status-title", TONE_TITLE_CLASS[tone])}>{title}</p> : null}
      <div className={classNames("app-status-body", title ? "app-status-body-with-title" : null)}>{children}</div>
    </div>
  );
}
